var RevistaSearch = RevistaSearch || {};

// ============================================================================
// TEMPLATES HTML
// ============================================================================

RevistaSearch.Templates = {

  skeleton() {
    return `
        <div class="search-result-item search-result-item--skeleton">
          <div class="search-result-item__cover skeleton-block skeleton-block--cover"></div>
          <div class="search-result-item__content">
            <div class="skeleton-block skeleton-block--tag"></div>
            <div class="skeleton-block skeleton-block--title"></div>
            <div class="skeleton-block skeleton-block--text"></div>
            <div class="skeleton-block skeleton-block--text"></div>
          </div>
        </div>`;
  },

  initialState(warningBlueIcon) {
    return `
        <div class="warning-blue" role="status" aria-live="polite">
          <div class="warning-blue__content">
            <img src="${warningBlueIcon}" width="34" height="34" alt="" />
            <span>Nenhum termo de busca foi informado. Digite uma palavra ou termo para realizar a busca.</span>
          </div>
        </div>`;
  },

  emptyState(safeQuery, emptySearchIcon) {
    return `
        <div class="tp-empty-state-illustration">
          <img src="${emptySearchIcon}"
               alt="Ilustração de uma mulher ao horizonte."
               aria-hidden="true" />
          <p><strong>Oops!</strong><br />
          Não encontramos resultado para: <strong class="search-keyword">${safeQuery}</strong></p>
          <p>Tente as sugestões a seguir ou digite uma nova consulta acima.</p>
          <ul>
            <li>Certifique-se de que todas as palavras estão escritas corretamente.</li>
            <li>Tente usar outras palavras com o mesmo significado.</li>
            <li>Tente palavras-chave mais genéricas.</li>
          </ul>
        </div>`;
  },

  errorState(safeMessage, errorIcon) {
    return `
        <div class="error-box" role="alert" aria-live="polite">
          <div class="error-box__content">
            <img src="${errorIcon}" width="34" height="34" alt="" />
            <span>${safeMessage}</span>
          </div>
        </div>`;
  },

  typeBadge(display) {
    return `<span class="search-result-item__type">${display}</span>`;
  },

  meta(typeConfig, revista, autor) {
    const edition = `<dt>Edição:</dt><dd>${revista}</dd>`;
    return typeConfig.showAuthor
      ? `${edition}\n            <dt>Autor:</dt><dd>${autor}</dd>`
      : edition;
  },

  cta(documentUrl, revistaUrl, verLabel = 'Ver edição') {
    return `
              <a href="${documentUrl}" class="btn btn--primary" target="_blank" rel="noopener noreferrer">${verLabel}</a>
              <a href="${revistaUrl}" class="btn btn--secondary" target="_blank" rel="noopener noreferrer">Acessar revista completa</a>`;
  },

  resultItem({ typeBadge, title, description, meta, cta, pdfIcon }) {
    return `
        <div class="search-result-item">
          <div class="search-result-item__cover">
            <img src="${pdfIcon}" alt="" width="50" height="50" />
          </div>
          <div class="search-result-item__content">
            ${typeBadge}<h3 class="search-result-item__title">${title}</h3>
            <div class="search-result-item__description"><p>${description}</p></div>
            <dl class="search-result-item__meta">
              ${meta}
            </dl>
            <div class="search-result-item__cta">
              ${cta}
            </div>
          </div>
        </div>`;
  },
};
